import src from "./case.png";
export default { src: src, aspect: 0.2688292319164802, width: 721, height: 2682 };